var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarDotes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.57146 5.28571C3.11681 5.28571 2.68077 5.46632 2.35928 5.78781C2.03779 6.1093 1.85718 6.54533 1.85718 6.99999V22.4286C1.85718 22.8832 2.03779 23.3193 2.35928 23.6407C2.68077 23.9622 3.11681 24.1428 3.57146 24.1428H22.4286C22.8833 24.1428 23.3193 23.9622 23.6408 23.6407C23.9623 23.3193 24.1429 22.8832 24.1429 22.4286V6.99999C24.1429 6.54533 23.9623 6.1093 23.6408 5.78781C23.3193 5.46632 22.8833 5.28571 22.4286 5.28571H19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.00006 1.85712V8.71426",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.0001 1.85712V8.71426",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.00006 5.28571H15.5715",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.00003 14.7143C7.47341 14.7143 7.85717 14.3305 7.85717 13.8571C7.85717 13.3838 7.47341 13 7.00003 13C6.52664 13 6.14288 13.3838 6.14288 13.8571C6.14288 14.3305 6.52664 14.7143 7.00003 14.7143Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13 14.7143C13.4734 14.7143 13.8572 14.3305 13.8572 13.8571C13.8572 13.3838 13.4734 13 13 13C12.5266 13 12.1429 13.3838 12.1429 13.8571C12.1429 14.3305 12.5266 14.7143 13 14.7143Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19 14.7143C19.4734 14.7143 19.8572 14.3305 19.8572 13.8571C19.8572 13.3838 19.4734 13 19 13C18.5266 13 18.1429 13.3838 18.1429 13.8571C18.1429 14.3305 18.5266 14.7143 19 14.7143Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.00003 19.8571C7.47341 19.8571 7.85717 19.4734 7.85717 19C7.85717 18.5266 7.47341 18.1428 7.00003 18.1428C6.52664 18.1428 6.14288 18.5266 6.14288 19C6.14288 19.4734 6.52664 19.8571 7.00003 19.8571Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarDotes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar_dotes.a6492bfdfc5119b97e19237f2ea2ec55.svg";